import React from 'react';
import { string, element, array, oneOfType } from 'prop-types';
import styled from 'styled-components';

import { Segment } from 'semantic-ui-react';


const Title = styled.h2`
    padding-bottom: 0.35rem;
    margin-bottom: 1.5rem !important;
`;

const Section = ({ name, children }) => (
    <Segment basic padded >
        <Title size="large">{ name }</Title>
        { children }
    </Segment>
);

Section.propTypes = {
    name: string.isRequired,
    children: oneOfType([element, array]).isRequired,
};

export default Section;
